const initialState = {
    page: 1,
    limit: 25
}

export default function paginationFreqAndPageReducer(state = initialState, action: any) {
    switch (action.type) {
        case "SET_PAGINATION_FREQ_AND_PAGE":
            return { ...state, page: action.payload.page, limit: action.payload.limit };
        default:
            return state;
    }
}